<template>
    <div class="footer">
        <!-- <div class="container">
            <div class="flex-item stse1">
                    <p class="ps1">服务热线</p>
                    <p class="ps1">400  1234  123456</p>
                    <p class="ps1">（周一至周五  9:00-19:00）</p>
                    <p class="ps1">公司地址：XX省xx市xx路街道</p>
            </div>
            <div class="flex-item stse1">
                <p class="ps1">APP下载</p>
                <p v>本产品解释权均归鹰瞳快速阅读所有</p>                                            
            </div>
            <div class="flex-item stse1">
                <p class="ps1">联系我们</p>
                <p class="ps1">根据你们的需要放</p>
            </div>
            <div class="flex-item stse2">
                <div class="imgs1"></div>
                <div class="imgs1"></div>
            </div>
        </div> -->
        <!-- <div class="center">
           <div class="serwe">
              <div>
                 APP下载<br/>
                 客服电话：  03158-164412
              </div>
           </div>
           <div class="serwe-right">
               <div class="imgs"></div>
               <div class="imgs"></div>
           </div>
        </div> -->
        <h1>为科技创新之飞跃而读书，为社会进步之繁荣而读书！</h1>
        <div class="file">
            <span class="url" @click="download('apk')">App下载(安卓)</span>
            <!-- <span class="url" @click="download('ipa')">App下载(ios)</span> -->
        </div>    
    </div>
</template>
<script>
import {getFileUrl} from "../api/home/index.js"
export default{
    data(){
        return{
            file:'',
            file1:'',
            type:''
        }
    },
    created() {
        this.getFile('apk')
        this.getFile('ipa')
        // this.getFile()
    },
    methods: {
        getFile(type){
            let data = {
                fileFix: type
            }
            getFileUrl(data).then((res)=>{
                if(type == 'apk') this.file = res.data.url
                if(type == 'ipa') this.file1 = res.data.url
                
            })
        },
        download(type){
            if(type == 'apk') window.location.href = this.file;
            if(type == 'ipa') window.location.href = this.file1;    
        }
    },
}
</script>


<style lang="scss" scope>
    .footer{
        width: 100%;
        //min-width: 1200px;
        //height: 288px;
        padding: 20px 0;
        color: #FFFFFF;
        background: #18243B;

        h1{
            text-align: center;
        }
        .center{
            max-width: 1400px;
            height: inherit;
            margin: 0 auto;
            .serwe{
                width: 50%;
                height: inherit;
                float: left;
                vertical-align:top;
                line-height: 100px;
            }
            .serwe-right{
                width: 50%;
                height: inherit;
                vertical-align:top;
                float: left;
                
                
            }
        }
    }

.container {
    width: 100%;
  display: flex;
  justify-content: space-around;
  height: 100%;
}

.flex-item {
  //flex: 1;
  
}
.conseset{
  height: 100%;
}

.ps1{
    //width: 300px;
    margin: 15px auto;
}

.imgs1{
    width: 150px;
    height: 150px;
    background: #FFFFFF;
    margin-left: 30px;
}
.stse1{
    padding-top: 70px;
}
.stse2{
    display: flex;
    justify-content: center;
    align-items: center;
}
.file{
    width: 95%;
    display: flex;
    justify-content: flex-end;
    span{
        display: block;
        margin-left: 20px;
    }
}
.url{
    cursor: pointer;
}
.url:hover{
    color: #2582E7;
}
</style>